import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'accent' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none ring-offset-white';
  const variants = {
    primary: 'bg-emerald-900 text-white hover:bg-emerald-800 focus-visible:ring-emerald-900',
    accent: 'bg-amber-600 text-white hover:bg-amber-700 focus-visible:ring-amber-600 shadow-lg shadow-amber-600/20',
    outline: 'border-2 border-emerald-900 text-emerald-900 hover:bg-emerald-50',
    ghost: 'text-emerald-900 hover:bg-emerald-50'
  };
  const sizes = {
    sm: 'h-9 px-3 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-50">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-51" />}
      {children}
    </button>;
}